import { themeVars } from '../themes/themeContract.css';

export const gradients = {
  aiGradientA: `radial-gradient(93.54% 235.77% at 3.38% 14.65%, ${themeVars.color.ai.color1} 0%, ${themeVars.color.ai.color2} 100%)`,
  aiGradientB: `radial-gradient(93.54% 235.77% at 3.38% 14.65%, ${themeVars.color.ai.color3} 0%, ${themeVars.color.ai.color1} 100%)`,
  aiGradientC: `radial-gradient(93.54% 235.77% at 3.38% 14.65%, ${themeVars.color.ai.color2} 0%, ${themeVars.color.ai.color1} 100%)`,
  aiGradientD: `radial-gradient(93.54% 235.77% at 3.38% 14.65%, ${themeVars.color.ai.color3} 0%, ${themeVars.color.brand.default} 100%)`,
  aiGradientE: `radial-gradient(93.54% 235.77% at 3.38% 14.65%, ${themeVars.color.ai.color1} 0%, ${themeVars.color.brand.light} 100%)`,
};
